import init from './flos-init.js';

document.addEventListener('DOMContentLoaded', (e) => {
    init(typeof initOptions !== 'undefined' ? initOptions : null);
});
